import * as React from "react";
import {WelcomeHeader} from "components/signup/shared/WelcomeHeader";
import {EmployeeOrSpouseBlock, EOS} from "components/signup/shared/EmployeeOrSpouseBlock";
import InvalidBubble from "components/signup/shared/InvalidBubble";
import {GDPR} from "components/signup/shared/GDPR";
import {action, observable} from "mobx";
import {UIState} from "data/UIState";
import {EMPTY_LOCATION, ILocation} from "data/entities/ILocation";
import {observer} from "mobx-react";
import {ButtonAction} from "../widgets/ButtonAction";
import {Alert} from "../../data/Alert";
import {POST_QUERY} from "utils";
import {API} from "api";



export default function Step1Basics(Props) {
return (
  <>
    <WelcomeHeader/>
    <Step1BasicsContent {...Props} />
  </>
);
}

/**
 * This step collects:
 *
 * - Employee or Spouse
 * - Location
 * - GDPR
 * - The "extra" field if configured
 *
 */
@observer
class Step1BasicsContent extends React.Component<Props> {
  @observable employeeName = '';
  @observable employeeOrSpouse = '';
  @observable extra = '';
  @observable location = EMPTY_LOCATION;

  @observable employeeOrSpouseInvalid = false;
  @observable locationInvalid = false;
  @observable gdprCheckFailed = false;
  @observable gdprAcceptanceStatus = !UIState.settings.ENABLE_GDPR;
  @observable employeeNameInvalid = false;
  @observable participationCode = "";
  @observable participationCodeFailed = false;

  @observable error = '';

  @action
  handleGDPRAcceptanceStatusChange = (gdprAcceptanceStatus:boolean) => {
    this.gdprAcceptanceStatus = gdprAcceptanceStatus;
  }

  @action handleLocationChange = (e) => {
    if(e.target.value==='') {
      this.location = EMPTY_LOCATION;
    } else {
      const possibleLocation = this.props.locations.find(l=>l._id===e.target.value);
      this.location = possibleLocation ? possibleLocation : EMPTY_LOCATION;
    }
  }

  @action
  continue = () => {
    this.participationCodeFailed = false;
    if(UIState.settings.ENABLE_PARTICIPATION_CODE) {

      API.post('/checkParticipationCode', {code:this.participationCode})
        .then(action(res => {
          if(res.success) {
            this.validate();
          } else {
            this.participationCodeFailed = true;
            Alert.alert('Your participation code is incorrect. Please try again.');
          }}))
        .catch((err) => {
          Alert.alert('Oops, something went wrong. Please try again.');
        })
    } else {
      this.validate();
    }
  }

  @action
  validate = () => {

    // clear GDPR question
    this.gdprCheckFailed = false;

    // Handle Partner Spouse fields
    if(UIState.settings.ASK_FOR_EMPLOYEE_OR_SPOUSE) {
      this.employeeOrSpouseInvalid = false;
      //this.spouseNameInvalid = false;
      this.employeeNameInvalid = false;

      if(!this.employeeOrSpouse) {
        this.employeeOrSpouseInvalid = true;
      } else if(this.employeeOrSpouse===EOS.spouse) {
        if(UIState.settings.NAME_OF_EMPLOYEE_IF_SPOUSE && !this.employeeName) {
          this.employeeNameInvalid = true;
        }
      }
    }

    if(this.props.locations.length>0) {
      this.locationInvalid = this.location._id === '';
    } else {
      this.locationInvalid = false;
    }

    if(this.gdprAcceptanceStatus && !this.locationInvalid && !this.employeeNameInvalid && !this.employeeOrSpouseInvalid && !this.locationInvalid) {

      this.props.continue(
        {
          employeeOrSpouse:this.employeeOrSpouse,
          employeeName: this.employeeName,
          location: this.location,
          extra: this.extra,
        }
      );

    } else {
      this.gdprCheckFailed = true;
      Alert.alert('There are fields that are incomplete. Please address these before you continue.');
    }
  }



  render() {


    return (
      <>



        {UIState.settings.ENABLE_PARTICIPATION_CODE && <>
          <div className="form-element">
            <label htmlFor={"participationCode"}>Enter participation code</label>
            <input
              type="text"
              id="participationCode"
              name="participationCode"
              value={this.participationCode}
              onChange={action((e: any) => {
                this.participationCode = e.target.value;
              })}
              placeholder={"participation code"}
              style={{minWidth: '250px'}}
            />
            <InvalidBubble label={`Participation code failed`} show={this.participationCodeFailed} />
          </div>
        </>}


        <EmployeeOrSpouseBlock
          employeeName={this.employeeName}
          updateEmployeeName={v => {
            this.employeeName = v;
          }}
          employeeOrSpouse={this.employeeOrSpouse}
          updateEmployeeOrSpouse={v => {
            this.employeeOrSpouse = v;
          }}
          employeeNameInvalid={this.employeeNameInvalid}
        />


        {this.props.locations.length>0 &&
          <div className={`form-element`}>
            <label htmlFor={"location"}>{UIState.settings.LOCATION_LABEL}</label>
            <select
                id={"location"}
                name="location"
                onChange={this.handleLocationChange}
                value={this.location._id}
            >
              <option value={''}>Select {UIState.settings.LOCATION_LABEL}...</option>
              {this.props.locations.map(location=><option key={location._id} value={location._id}>{location.name}</option>)}
            </select>
            <InvalidBubble label={`${UIState.settings.LOCATION_LABEL} is required`} show={this.locationInvalid} />
          </div>
        }



        {UIState.settings.EXTRA_FIELD && UIState.settings.EXTRA_FIELD.enabled &&
          <div className="form-element">
            <label htmlFor={"extra"}>{UIState.settings.EXTRA_FIELD.title} </label>
            <p className="hint">{UIState.settings.EXTRA_FIELD.hint} </p>

            {UIState.settings.EXTRA_FIELD.options ?
              <select
                  name="extra"
                  id="extra"
                  onChange={action((e)=>{
                    this.extra = e.target.value;
                  })}
                  value={this.extra}
              >
                <option value={''}>Select {UIState.settings.EXTRA_FIELD.title}...</option>
                {UIState.settings.EXTRA_FIELD.options.map((opt, idx)=><option key={idx} value={opt.value}>{opt.label}</option>)}
              </select>
              :
              <textarea
                  id={"extra"}
                  value={this.extra}
                  onChange={action((e: any) => {
                    this.extra = e.target.value;
                  })}
                  style={{width: '80%', height: '60px', marginTop:'8px'}}
              />
            }
          </div>
        }


        {UIState.settings.ENABLE_GDPR &&
          <GDPR onStatusChange={this.handleGDPRAcceptanceStatusChange} checkFailed={this.gdprCheckFailed} />
        }

        <div className={'form-element tight'}>
          {/*<ButtonAction onClick={this.validateWhoAndTermsStep} className={"cta-button"}>Continue</ButtonAction>*/}
          <a tabIndex={0} className="cta-button noselect" onClick={this.continue}>Continue</a>
          {this.error && <p className="error">{this.error}</p>}
        </div>

      </>
    )
  }
}






export interface IBasicsData  {
  employeeName:string;
  employeeOrSpouse:string;
  location:any;
  extra:string;
}


interface Props {
  continue:(data:IBasicsData)=>void;
  locations:ILocation[]
}

